<section class="banner-one" id="home">
            <div class="container">
                <div class="banner-one__moc-wrap">
                    <img src="{{config.header.image}}" class="banner-one__moc" alt="{{config.skinName}}" />
                </div><!-- /.banner-one__moc-wrap -->
                <div class="textContainer row justify-content-start">
                    <div class="col-lg-5 col-md-6">
                        <div class="banner-one__content">
                            <h3 *ngIf="config.partner !=17" class="banner-one__title title-affiliates">{{config.skinName | translate}}  <br> <span class="sub-title-affiliates">{{'Afiliados ' | translate}}</span> </h3>
                            <h3 *ngIf="config.partner == 17" class="banner-one__title title-affiliates"> <span class="title-one"> Programa </span><br><span class="title-two">de afiliados </span> <span class="title-three">Sua Renda merece um <span class="title-four">up</span></span> </h3>
                            <!-- /.banner-one__title -->
                            <p *ngIf="config.partner != 17" class="banner-one__text">{{config.header.text}}</p><!-- /.banner-one__text -->
                            <a *ngIf="config.partner != 17" [routerLink]="['/register']" class="banner-one__btn thm-btn" translate>Afiliarme</a>
                            <a *ngIf="config.partner != 17" [routerLink]="['/terms-conditions']" class="banner-one__btn tc" translate>Ver T&C</a>
                        </div><!-- /.banner-one__content -->
                    </div><!-- /.col-lg-5 -->
                </div><!-- /.row justify-content-end -->
            </div><!-- /.container -->
        </section><!-- /.banner-one -->
        
        <section *ngIf="config.partner == 17" class="service-one-milbets">
            <div class="container-service-one-milbets h-full flex flex-col md:flex-row h-auto">
                <div class="w-full md:w-[400px] h-[90%] p-3">
                    <p class="text-[#20446f] text-3xl font-black">Sobre a Milbets</p>
                    <p>A Milbets é uma empresa consolidada no mercado nacional de apostas. Desde 2017, atuando no mercado físico, a Milbets não para de atrair clientes.</p>
                    <p> Visto o grande potencial do mercado de apostas online, em 2022 a Milbets amplia sua gama de serviços, pensando no melhor atendimento ao nosso cliente.</p>
                    <p>Assim, temos uma estrutura 100% apta para atender todos os públicos de apostadores. E consequentemente, aumentar nosso market share no mercado nacional, possibilitando cada vez mais que nossos clientes tenham a melhor experiência com o entretenimento online.</p>
                </div>
                <div style="width: 35%; height: 80%; background-color: white;" class="bg-clifford">
                    <img src="https://images.virtualsoft.tech/m/msjT1681410290.png" alt="about-us" style="object-fit: contain; width: 100%; height:100%;"> 
                </div>
            </div>
        </section>
        <section *ngIf="config.partner == 17" class="service-one-milbets h-auto py-[150px]" id="quem-somos">
            <div class="container-service-one-milbets h-full flex flex-col md:flex-row" >
                <div class="w-[20%] flex justify-end text-[#00ff76]">
                    <p style=" font-weight: 100;" class="text-3xl text-rotate">Quem <span style="font-weight: 900;">somos?</span></p>
                </div>
                <div class="w-full md:w-[30%] h-[90%] bg-white pl-[20px]">
                    <p class="text-[#20446f] text-5xl font-black">Missão</p>
                    <p>Existimos para trazer entretenimento nas apostas online em outro nível. Com conectividade, responsabilidade e inovação temos a missão de levar aos nossos clientes a melhor experiência dentro de uma plataforma de entretenimento. </p>
                    <p class="text-[#20446f] text-5xl font-black">Visão</p>
                    <p>Assim, temos uma estrutura 100% apta para atender todos os públicos de apostadores. E consequentemente, aumentar nosso market share no mercado nacional, possibilitando cada vez mais que nossos clientes tenham a melhor experiência com o entretenimento online.</p>
                    <p class="text-[#20446f] text-5xl font-black">Valores</p>
                    <p> Visto o grande potencial do mercado de apostas online, em 2022 a Milbets amplia sua gama de serviços, pensando no melhor atendimento ao nosso cliente.</p>
                </div>
                <div style="width: 50%; height: 80%; background-color: white;" class="flex justify-end items-start">
                    <img src="https://images.virtualsoft.tech/m/msjT1681419620.png" alt="about-us" style="object-fit: contain; width: 70%; height:100%;"> 
                </div>
            </div>
        </section>

        <section *ngIf="config.partner == 17" class="service-one-milbets h-auto" id="vantagens">
            <div class="container-service-one-milbets h-full flex flex-col md:flex-row">
                <div style="width: 20%; height: 80%; background-color: white;" class="flex justify-start items-start hidden md:block">
                    <img src="https://images.virtualsoft.tech/m/msjT1681423899.png" alt="about-us" style="object-fit: contain; width: 40%; height:100%;"> 
                </div>
                <div class="w-[60%] h-[90%] bg-white pl-[20px] flex flex-row flex-wrap justify-center p-0">
                    
                    <div class="w-full md:w-[33%] flex flex-col justify-center items-center gap-6">
                        <img src="https://images.virtualsoft.tech/m/msjT1681423593.png" alt="text-one" width="120">
                        <p class="text-[#20446f] text-2xl font-black">Streaming</p>
                        <p>Nosso site apresenta uma nova
                            tecnologia que permite os nossos
                            clientes assistirem aos jogos ao vivo. O objetivo é tornar nosso site mais conectado com o seu
                            palpite.</p>
                    </div>
                    <div class="w-full md:w-[33%] flex flex-col justify-center items-center gap-6">
                        <img src="https://images.virtualsoft.tech/m/msjT1681423644.png" alt="text-one" width="120">
                        <p class="text-[#20446f] text-2xl font-black">Cash out</p>
                        <p>Nosso site apresenta uma nova
                            tecnologia que permite os nossos
                            clientes assistirem aos jogos ao vivo. O objetivo é tornar nosso site mais conectado com o seu
                            palpite.</p>
                    </div>
                    <div class="w-full md:w-[33%] flex flex-col justify-center items-center gap-6">
                        <img src="https://images.virtualsoft.tech/m/msjT1681423683.png" alt="text-one" width="120">
                        <p class="text-[#20446f] text-2xl font-black">Diversidade</p>
                        <p>Nosso site apresenta uma nova
                            tecnologia que permite os nossos
                            clientes assistirem aos jogos ao vivo. O objetivo é tornar nosso site mais conectado com o seu
                            palpite.</p>
                    </div>

                    <div class="w-full flex flex-col justify-center items-center gap-6 mt-[117px]">
                        <p class="text-[#00ff76] text-2xl font-black">Streaming Mil ON</p>
                        
                        
                        <div class=" w-full flex flex-col md:flex-row items-center justify-center">
                            <div class="w-full md:w-[20%]">
                                <p class="p-3 font-black">Nosso streaming
                                    está disponível para
                                    todos gratuitamente.
                                    </p>
                                <img src="https://images.virtualsoft.tech/m/msjT1681483538.png" alt="group-one">
                            </div>
                            
                            <div class="w-full md:w-[60%]">
                                <img src="https://images.virtualsoft.tech/m/msjT1681481115.png" alt="group-one">
                            </div>
                            
                            <div class="md:w-[20%]">
                            </div>
                        </div>


                        <div class="w-full flex flex-col md:flex-row items-center justify-center">
                            <div class="w-[20%]">
                               
                            </div>
                            
                            <div class="w-full md:w-[60%]">
                                <img src="https://images.virtualsoft.tech/m/msjT1681481226.png" alt="group-one">
                            </div>
                            
                            <div class="w-full md:w-[20%]">
                                <img src="https://images.virtualsoft.tech/m/msjT1681483953.png" alt="group-one">
                                <p class="p-3 font-black">Disponível somente
                                    após depósito.
                                    </p>
                            </div>
                        </div>


                        <div class="w-full flex flex-col md:flex-row items-center justify-center">
                            <div class="w-full md:w-[20%]">
                                <p class="p-3 font-black">Sem streaming.
                                    Disponível  apenas
                                    campo virtual.
                                    </p>
                            </div>
                            
                            <div class="w-full md:w-[60%]">
                                <img src="https://images.virtualsoft.tech/m/msjT1681481271.png" alt="group-one">
                            </div>
                            
                            <div class="w-[20%]">
                                
                            </div>
                        </div>


                    </div>

                </div>
                <div style="width: 20%; height: 100%; background-color: white;" class="hidden md:flex justify-end items-start">
                    <img src="https://images.virtualsoft.tech/m/msjT1681423899.png" alt="about-us" style="object-fit: contain; width: 40%; height:100%; transform: rotate(180deg);"> 
                </div>
            </div>
        </section>
        
        <section *ngIf="config.partner == 17">
            <div class="w-full h-auto mt-[209px]">
                <div class="w-full flex justify-center items-center flex-wrap gap-x-3 gap-y-9">
                    <div class="w-full relative flex flex-col md:flex-row justify-center">
                        <div class="relative w-[100px]">
                            <img src="https://images.virtualsoft.tech/m/msjT1681496684.png" class="absolute top-0 left-0 -mt-[20px] md:-mt-[54px]"  width="90" alt="">
                        </div>
                        <p class="text-[#20446f] text-2xl md:text-5xl text-center font-black w-full md:w-[50%]">Nossos provedores</p>
                    </div>
                    <div class="p-3 w-[26.6%] flex justify-center items-center">
                        <img src="https://images.virtualsoft.tech/m/msjT1681494812.png" alt="">
                    </div>
                    <div class="p-3 w-[26.6%] flex justify-center items-center">
                        <img src="https://images.virtualsoft.tech/m/msjT1681494960.png" alt="">
                    </div>
                    <div class="p-3 w-[26.6%] flex justify-center items-center">
                        <img src="https://images.virtualsoft.tech/m/msjT1681494979.png" alt="">
                    </div>


                    <div class="p-3 w-[26.6%] flex justify-center items-center">
                        <img src="https://images.virtualsoft.tech/m/msjT1681495000.png" alt="">
                    </div>

                    <div class="p-3 w-[26.6%] flex justify-center items-center">
                        <img src="https://images.virtualsoft.tech/m/msjT1681495218.png" alt="">
                    </div>
                    
                    <div class="p-3 w-[26.6%] flex justify-center items-center">
                        <img src="https://images.virtualsoft.tech/m/msjT1681495037.png" alt="">
                    </div>

                    <div class="p-3 w-[26.6%] flex justify-center items-center">
                        <img src="https://images.virtualsoft.tech/m/msjT1681495057.png" alt="">
                    </div>

                    <div class="p-3 w-[26.6%] flex justify-center items-center">
                        <img src="https://images.virtualsoft.tech/m/msjT1681495072.png" alt="">
                    </div>

                    <div class="p-3 w-[26.6%] flex justify-center items-center">
                        <img src="https://images.virtualsoft.tech/m/msjT1681495085.png" alt="">
                    </div>

                    <div class="p-3 w-[26.6%] flex justify-center items-center">
                        <img src="https://images.virtualsoft.tech/m/msjT1681495100.png" alt="">
                    </div>

                    <div class="p-3 w-[26.6%] flex justify-center items-center">
                        <img src="https://images.virtualsoft.tech/m/msjT1681495121.png" alt="">
                    </div>

                    <div class="p-3 w-[26.6%] flex justify-center items-center">
                        <img src="https://images.virtualsoft.tech/m/msjT1681495138.png" alt="">
                    </div>

                    <div class="w-full relative flex justify-center mt-8">
                        <p class="text-[#20446f] text-xl md:text-5xl text-center font-black w-[50%]">e muito mais...</p>
                        <div class="relative w-[100px]">
                            <img src="https://images.virtualsoft.tech/m/msjT1681504130.png" class="absolute top-0 left-0 -mb-[54px]"  width="90" alt="">
                        </div>
                    </div>
                </div>
                
            </div>
        </section>

        <section *ngIf="config.partner == 17" class="flex justify-center mt-[160px]" id="seja-um-afiliado">
            <div class="w-full h-auto px-8 flex justify-center items-center flex-wrap flex-col md:flex-row">
                <div class="w-full md:w-2/4 flex justify-center items-center p-8 md:p-0">
                    <img src="https://images.virtualsoft.tech/m/msjT1681505088.png" alt="">
                </div>
                <div class="w-full md:w-2/4">
                    <p class="text-2xl md:text-5xl font-black text-left w-full md:w-[451px]">O que fazemos
                        por você?</p>
                        <p>Assessoria personalizada para afiliado<br>

                            Meterial de divulgação (Mídia Kit) <br>Comissões progressivas Plataforma exclusiva para afiliados</p>
                </div>
            </div>
        </section>

        <section *ngIf="config.partner == 17" class="mt-[100px]" id="comissoes">
            <div class="w-full p-9 flex justify-center items-center">
                <div class="w-full md:w-[30%] flex flex-col justify-end items-start pl-0 md:pl-[189px]">
                    <p class="text-lg md:text-4xl font-black">A Milbets oferece comissões progressivas</p>
                    <p class="bg-[#00ff88] p-2 font-black text-xl md:text-4xl">10% a 35%</p>
                </div>
                <div class="w-full md:w-[30%] flex justify-start">
                    <img src="https://images.virtualsoft.tech/m/msjT1681506529.png" alt="" width="709" class="md:-ml-[103px]">
                </div>
            </div>
        </section>

        <section *ngIf="config.partner == 17">
            <div class="w-full flex justify-center p-5 md:p-0">
                <img src="https://images.virtualsoft.tech/m/msjT1681511005.png" alt="">
            </div>
        </section>

        <section *ngIf="config.partner == 17" class="mt-[150px]">
            <div class="w-full flex justify-center">
                <img src="https://images.virtualsoft.tech/m/msjT1681511187.png" class="w-full object-cover" alt="">
            </div>
        </section>

        <section *ngIf="config.partner != 8 && config.partner != 17" class="service-one" id="about-us">
            <div class="container">
                <div class="block-title text-center">
                    <h2 class="block-title__title title-about-us" translate>¿Quiénes somos?<br></h2><!-- /.block-title__title -->
                </div><!-- /.block-title -->
                <div class="row">
                    <div class="col-lg-3 who" *ngFor="let item of homeAboutUs">
                        <div class="service-one__single">
                            <div class="service-one__icon icon-about-us">
                                <i class="appyn-icon-target-1"><i class="{{item.icon}}"></i></i>
                            </div><!-- /.service-icon -->
                            <h3 class="service-one__title sub-title-about-us"><a href="#">{{item.title}}</a></h3>
                            <!-- /.service-one__title -->
                            <p class="service-one__text sub-text-about-us" [innerHTML]="item.text"></p><!-- /.service-one__text -->
                        </div><!-- /.service-one__single -->
                    </div><!-- /.col-lg-4 -->
                </div><!-- /.row -->
            </div><!-- /.container -->
        </section><!-- /.service-one -->
        <section *ngIf="config.partner == 8" class="service-one" id="about-us">
            <div class="container">
                <div class="block-title text-center">
                    <h2 class="block-title__title" translate>Acerca de Nosotros<br></h2><!-- /.block-title__title -->
                </div><!-- /.block-title -->
                <div class="row">
                    <div class="col-lg-4 who" *ngFor="let item of homeAboutUs">
                        <div class="service-one__single">
                            <div class="service-one__icon">
                                <i class="appyn-icon-target-1"><i class="{{item.icon}}"></i></i>
                            </div><!-- /.service-icon -->
                            <h3 class="service-one__title"><a href="#">{{item.title}}</a></h3>
                            <!-- /.service-one__title -->
                            <p class="service-one__text">{{item.text}}</p><!-- /.service-one__text -->
                        </div><!-- /.service-one__single -->
                    </div><!-- /.col-lg-4 -->
                </div><!-- /.row -->
                <div class="bets_daily block-title text-center">
                    <h2 class="block-title__title bets_count">10.600.600+<br></h2>
                    <h2 class=" bets">APUESTAS DIARIAS<br></h2><!-- /.block-title__title -->
                </div>
                <br>
                <div class="row">
                    <div class="col-lg-3 extras" *ngFor="let item of homeAboutUsExtras">
                        <div class="service-one__single">
                            <div class="service-one__icon">
                                <i class="appyn-icon-target-1"><i class="{{item.icon}}"></i></i>
                            </div><!-- /.service-icon -->
                            <!-- /.service-one__title -->
                            <p class="service-one__text">{{item.text}}</p><!-- /.service-one__text -->
                        </div><!-- /.service-one__single -->
                    </div><!-- /.col-lg-4 -->
                </div>
            </div><!-- /.container -->
        </section><!-- /.service-one -->
        <section *ngIf="config.partner == 8" class="service-one" id="benefit">
            <div class="container">
                <div class="block-title text-center">
                    <h2 class="block-title__title" translate>¿Quién se puede beneficiar de este programa?<br></h2><!-- /.block-title__title -->
                </div><!-- /.block-title -->
                <div class="row">
                    <div class="col-lg-4 who" *ngFor="let item of homeBenefit" style="border-left: none;">
                        <div class="service-one__single">
                            <div class="service-one__icon">
                                <i class="appyn-icon-target-1"><i class="{{item.icon}}"></i></i>
                            </div><!-- /.service-icon -->
                            <h3 class="service-one__title"><a href="#">{{item.title}}</a></h3>
                            <!-- /.service-one__title -->
                            <p class="service-one__text">{{item.text}}</p><!-- /.service-one__text -->
                        </div><!-- /.service-one__single -->
                    </div><!-- /.col-lg-4 -->
                </div><!-- /.row -->
            </div><!-- /.container -->
        </section><!-- /.service-one -->
        <section *ngIf="config.partner == 8" class="service-one" id="why">
            <div class="container text-break">
                <div class="block-title text-center">
                    <h2 class="block-title__title" translate>¿Por qué Ecuabet?<br></h2><!-- /.block-title__title -->
                </div><!-- /.block-title -->
                <div class="row">
                    <table class="table table-bordered">
                      <thead>
                        <tr style="border-bottom: 1px solid black">
                          <th scope="col"></th>
                          <th scope="col">Programa Afiliados de Ecuabet</th>
                          <th scope="col">Programa Afiliados de otra casa de Apuestas y Casinos</th>
                          <th scope="col">Publicidad libre de tarifas</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row">Estabilidad</th>
                          <td><i class="fas fa-check-circle"></i></td>
                          <td><i class="fas fa-times-circle"></i></td>
                          <td><i class="fas fa-times-circle"></i></td>
                        </tr>
                        <tr>
                          <th scope="row">Lealtad</th>
                          <td><i class="fas fa-check-circle"></i></td>
                          <td><i class="fas fa-times-circle"></i></td>
                          <td><i class="fas fa-times-circle"></i></td>
                        </tr>
                        <tr>
                          <th scope="row">Crecimiento en ingresos</th>
                          <td><i class="fas fa-check-circle"></i></td>
                          <td><i class="fas fa-check-circle"></i></td>
                          <td><i class="fas fa-times-circle"></i></td>
                        </tr>
                        <tr>
                          <th scope="row">Bonificacion por cumplimiento</th>
                          <td><i class="fas fa-check-circle"></i></td>
                          <td><i class="fas fa-times-circle"></i></td>
                          <td><i class="fas fa-times-circle"></i></td>
                        </tr>
                        <tr>
                          <th scope="row">Publicidad facil de controlar</th>
                          <td><i class="fas fa-check-circle"></i></td>
                          <td><i class="fas fa-times-circle"></i></td>
                          <td><i class="fas fa-times-circle"></i></td>
                        </tr>
                      </tbody>
                    </table>
                </div><!-- /.row -->
            </div><!-- /.container -->
            <br>
        </section><!-- /.service-one -->
        <section *ngIf="config.partner == 8" class="service-one" id="workProfitable">
            <div class="container">
                <div class="block-title text-center">
                    <h2 class="block-title__title" translate>¿Por qué trabjar con nosotros es rentable?<br></h2><!-- /.block-title__title -->
                </div><!-- /.block-title -->
                <div class="row">
                    <div class="col-lg-4 who" *ngFor="let item of workProfitable">
                        <div class="service-one__single">
                            <div class="service-one__icon">
                                <i class="appyn-icon-target-1"><i class="{{item.icon}}"></i></i>
                            </div><!-- /.service-icon -->
                            <h3 class="service-one__title"><a href="#">{{item.title}}</a></h3>
                            <!-- /.service-one__title -->
                            <p class="service-one__text" [innerHTML]="item.text" style="text-align: left;"></p><!-- /.service-one__text -->
                        </div><!-- /.service-one__single -->
                    </div><!-- /.col-lg-4 -->
                </div><!-- /.row -->
            </div><!-- /.container -->
        </section><!-- /.service-one -->
        <section *ngIf="config.partner == 8" class="service-one" id="makeMoney">
            <div class="container text-break">
                <div class="block-title text-center">
                    <h2 class="block-title__title">¿Cómo empezar a <br><span class="make">hacer dinero?</span><br></h2><!-- /.block-title__title -->
                </div><!-- /.block-title -->
                <div class="row">
                    <div class="col-lg-4 who" *ngFor="let item of makeMoney">
                        <div class="service-one__single">
                            <div class="service-one__icon">
                                <i class="appyn-icon-target-1"><i class="{{item.icon}}"></i></i>
                            </div><!-- /.service-icon -->
                            <h3 class="service-one__title"><a href="#">{{item.title}}</a></h3>
                            <!-- /.service-one__title -->
                            <p class="service-one__text" [innerHTML]="item.text" style="text-align: left;"></p><!-- /.service-one__text -->
                        </div><!-- /.service-one__single -->
                    </div><!-- /.col-lg-4 -->
                </div><!-- /.row -->
            </div><!-- /.container -->
        </section><!-- /.service-one -->
        <section *ngIf="config.partner == 8" class="service-one p-2" id="howRegister">
            <div class="container">
                <div class="block-title text-center">
                    <h2 class="block-title__title" translate>¿Cómo registrarse?<br></h2><!-- /.block-title__title -->
                </div><!-- /.block-title -->
                <br>
                <div class="row">
                    <div class="container">
                       
                        <div class="row align-items-center how-it-works d-flex">
                          <div class="col-2 text-center bottom d-inline-flex justify-content-center align-items-center">
                            <div class="circle font-weight-bold">1</div>
                          </div>
                          <div class="col-6">
                            <h5>Ingresa en</h5>
                            <h5 class="url_ec">https://afiliados.ecuabet.com</h5>
                            
                          </div>
                        </div>
                        <!--path between 1-2-->
                        <div class="row timeline">
                          <div class="col-2">
                            <div class="corner top-right"></div>
                          </div>
                          <div class="col-8">
                            <hr/>
                          </div>
                          <div class="col-2">
                            <div class="corner left-bottom"></div>
                          </div>
                        </div>
                        <!--second section-->
                        <div class="row align-items-center justify-content-end how-it-works d-flex">
                          <div class="col-6 text-right">
                            <h5>Llena todos los campos</h5>
                            
                          </div>
                          <div class="col-2 text-center full d-inline-flex justify-content-center align-items-center">
                            <div class="circle font-weight-bold">2</div>
                          </div>
                        </div>
                        <!--path between 2-3-->
                        <div class="row timeline">
                          <div class="col-2">
                            <div class="corner right-bottom"></div>
                          </div>
                          <div class="col-8">
                            <hr/>
                          </div>
                          <div class="col-2">
                            <div class="corner top-left"></div>
                          </div>
                        </div>
                        <!--third section-->
                        <div class="row align-items-center how-it-works d-flex">
                          <div class="col-2 text-center top d-inline-flex justify-content-center align-items-center">
                            <div class="circle font-weight-bold">3</div>
                          </div>
                          <div class="col-6">
                            <h5>¡Tu cuenta ha sido creada!</h5>
                            
                          </div>
                        </div>
                      </div>
                </div><!-- /.row -->
            </div><!-- /.container -->
        </section><!-- /.service-one -->
        
        <section *ngIf="config.partner == 8" class="service-one" id="howCreateLink">
            <div class="container">
                <div class="block-title text-center">
                    <h2 class="block-title__title" translate>Cómo crear tu link<br></h2><!-- /.block-title__title -->
                </div><!-- /.block-title -->
                <br>
                <div class="row">
                    <div class="container">
                      <div class="row">
                        <div class="col img-link"><img class="link-1 img" src="https://images.virtualsoft.tech/m/msjT1641908026.png" alt=""></div>
                        <div class="col"><h3 class="service-one__title">UNA VEZ ACEPTADA TU CUENTA</h3>
                            <!-- /.service-one__title -->
                            <ul>
                                <li>Inicia sesion en nuestra pagina</li>
                                <li>Digite al dashboard</li>
                                <li>Selecciona la opcion Lista de links</li>
                                <li>En el lado derecho podras ver la opcion Crear link</li>       
                            </ul>

                        </div>
                        <div class="w-100"></div>
                        <div class="col">
                            <ul>
                                <li>Registra un nombre para idetificar tu Link</li>
                                <li>Puedes crear mas de un link dependiendo de tu necesidad o tu manejo de redes y pagina web</li>
                                <li>Seleccion la pagina de Ecuabet donde desees que lleve este Link a tus jugadores, puede ser:</li>
                                <div class="pgs">
                                    <h3 class="service-one__title sc">- HOME</h3>
                                    <h3 class="service-one__title sc">- REGISTRO</h3>
                                    <h3 class="service-one__title sc">- DEPORTES</h3>
                                </div>
                                

                                <li>Presiona crear</li>
                            </ul>


                        </div>
                        <div class="col img-link"><img class="link-2" src="https://images.virtualsoft.tech/m/msjT1641907971.png" alt=""></div>
                      </div>
                    </div>
                </div><!-- /.row -->
            </div><!-- /.container -->
        </section>
        <section *ngIf="config.partner == 8" class="service-one" id="CreatedLink">
            <div class="container">
                <div class="block-title text-center">
                    <h2 class="block-title__title cutm">¡Tu link ha sido creado!<br></h2><!-- /.block-title__title -->
                </div><!-- /.block-title -->
                <br>
                <div class="row">
                    <ul class="link_creat">
                        <li>En la opcion <b>"Links"</b> puedes revisar todos los que has creado</li>
                        <li>Puedes <b>revisar los ussuarios que se han registrado</b> a través de tu link</li>
                        <li><b>Medir</b> los clicks y tus ganancias obtenidas</li>
                        <li>Tu link se verá así:</li>
                        <div class="utm">https://ecuabet.com//?btag=2basd4a5646das9dasd79879879&utm_source=Afiliados&utm_medium=Link&utm_campaign=Esteban_RRSS</div>
                        <li>Esta informacion la debes <b>compartir en tu redes sociales o sitios web.</b></li>
                    </ul>
                </div><!-- /.row -->
            </div><!-- /.container -->
            <br>
        </section>
        <section *ngIf="config.partner == 8" class="service-one" id="howMakeAds">
            <div class="container">
                <div class="block-title text-center">
                    <h2 class="block-title__title" translate>¿Cómo haces publicidad?<br></h2><!-- /.block-title__title -->
                </div><!-- /.block-title -->
                <br>
                <div class="row">
                    <div class="container">
                      <div class="row">
                        <div class="col-sm col-12 img-mano"><img class="mano" src="https://images.virtualsoft.tech/m/msjT1641915901.png" alt=""></div>
                        <div class="col">
                            <!-- /.service-one__title -->
                            <ul>
                                <li><div class="num-a">1.</div><div class="txt-a">Genera un link de afiliado unico</div></li>
                                <li><div class="num-a">2.</div><div class="txt-a">Coloca los anuncios en tu sitio web y redes sociales</div></li>
                                <li><div class="num-a">3.</div><div class="txt-a">Crea informes estadísticos</div></li>    
                            </ul>

                        </div>
                       
                      </div>
                    </div>
                </div><!-- /.row -->
            </div><!-- /.container -->
            <br>
        </section>
        <section *ngIf="config.partner == 8" class="service-one" id="GenerateLink">
            <div class="container">
                <br>
                <div class="block-title text-center">
                    <h2 class="block-title__title cutm">GENERA UN LINK DE AFILIADO ÚNICO<br></h2><!-- /.block-title__title -->
                </div><!-- /.block-title -->
                <div class="row" style="width: 100%; margin: 0 auto;">
                    <p>Esto le permite rastrear facilmente las acciones de los usuarios que siguen el enlace en su anuncio</p>
                    <p>Quienes se registran bajo su link, deben realizar un deposito y luego una apuesta, por cada juego realizado, <b>¡ganas!</b></p>
                    <p>Para crear un enlace de socio, inicie sesión con su cuenta y presione en la opcion <b>"crear link"</b> en el Menu de Dashboard.</p>
                    
                </div><!-- /.row -->
                <br>
                <br>
                <div class="block-title text-center">
                    <h2 class="block-title__title cutm">COLOCA EL LINK EN TU SITIO WEB Y REDES SOCIALES<br></h2><!-- /.block-title__title -->
                </div><!-- /.block-title -->
                <h3>PUEDES UTILIZAR LAS SIGUIENTES FUENTES DE TRÁFICO:</h3>
                <div class="row" style="width: 100%; margin: 0 auto;">
                    <ul>
                        <li>Paginas web, landing pages</li>
                        <li>Redes sociales o blogs</li>
                        <li>Correo directo</li>
                        <li>Publicidad en banners</li>
                        <li>Videos</li>
                        <li>Capacitando</li>
                        <li>Publicidad teaser (aparecer debajo y hacer click debajo de los anuncios)</li>
                        <li>Publicidad viral</li>
                        <li>Foros</li>
                    </ul>
                </div>
                <br>
                <div class="block-title text-center">
                    <h2 class="block-title__title cutm">CREA INFORMES ESTADISTICOS<br></h2><!-- /.block-title__title -->
                </div><!-- /.block-title -->
                <div class="row" style="width: 100%; margin: 0 auto;">
                    <p>Su publicidad sera mas eficiente mediante el estudio de informes estadisticos, asi podra ajustar su estrategia acorde a los resultados.</p>
                    <p>Ademas de las estadisticas rapidas, tendra disponibles los siguientes tipos de informes:</p>    
                </div>
                <ul>
                            <li>REPORTE COMPLETO</li>
                            <li>RESUMEN</li>
                            <li>INFORME DE JUGADOR</li>
                            <li>INFORME MATERIAL PROMOCIONAL</li>
                        </ul>
                
            </div><!-- /.container -->
            <br>
        </section>
        <section *ngIf="config.partner == 8" class="service-one" id="howGetEarnings">
            <div class="container text-break">
                <div class="block-title text-center">
                    <h2 class="block-title__title" translate>¿Cómo obtener tus ganancias?<br></h2><!-- /.block-title__title -->
                </div><!-- /.block-title -->
                <br>
                <div class="row" style="width: 100%; margin: 0 auto;">
                    <div class="container">
                      <ul>
                          <li><div class="num-a"><i class="far fa-credit-card"></i></div><div class="txt-a">Debes tener activa tu cuenta bancaria personal.</div></li>
                          <li><div class="num-a"><i class="fas fa-hand-holding-usd"></i></div><div class="txt-a">Los pagos se realizarán mediante efectivo o transferencia.</div></li>
                            
                      </ul>
                    </div>
                </div><!-- /.row -->
            </div><!-- /.container -->
            <br>
        </section>
        <section *ngIf="config.partner == 8" class="service-one" id="successStories">
            <div class="container">
                <div class="block-title text-center">
                    <h2 class="block-title__title" translate>¿Historias de Éxito?<br></h2><!-- /.block-title__title -->
                </div><!-- /.block-title -->
                <br>
                <div class="row">
                    <div class="container">
                      <div class="row">
                        <div class="col">
                            <img class="link-1" src="https://images.virtualsoft.tech/m/msjT1641934191.png" alt="">
                            <h3 class="nm">LUIS PORTILLA, QUITO</h3>
                            <p>Trabajo con Ecuabet hace 2 años y 6 meses.</p>
                            <p>Gracias a Ecuabet pude cumplir mi sueño de tener mi auto propio, por todos los ingresos que he generado con su plan de afiliados. Cada vez mas personas quieren formar parte.</p>
                        </div>
                        <div class="col">
                            <img class="link-1" src="https://images.virtualsoft.tech/m/msjT1641934227.png" alt="">
                            <h3 class="nm">HUGO RICARDO FALCON, GUAYAQUIL</h3>
                            <p>Trabajo con Ecuabet hace 6 meses.</p>
                            <p>Desde que estoy con Ecuabet mis ingresos han ido creciendo de mandera exponencial. Estoy muy feliz porque he logrado pagar mis deudas y comprar una casa para mi familia.</p>
                            <p>Todo gracias a Ecuabet.</p>

                        </div>
                      </div>
                    </div>
                </div><!-- /.row -->
            </div><!-- /.container -->
        </section>
        <section *ngIf="config.partner == 13" class="imgPoker" id="imgPoker">
            <div class="container-img-poker">
                <img src="https://images.virtualsoft.tech/m/msjT1672850778.png" alt="" class="PokerImg">
            </div><!-- /.container -->
            <br>
        </section>
        <section *ngIf="config.partner == 8" class="service-one" id="workWithUs">
            <div class="container">
                <div class="block-title text-center">
                    <h1 class="block-title__title">¡EMPIEZA A TRABAJAR CON NOSOTROS!<br></h1><!-- /.block-title__title -->
                </div><!-- /.block-title -->
                <br>
                <div class="row">
                    <div class="container text-center">
                      <div class="row">
                        <div class="col">

                            <h2>Contáctanos:</h2>
                            <h2 class="wb">AFILIADOS@ECUABET.COM</h2>

                        </div>
                        <div class="col">
                           
                            <h2>Regístrate en la página web:</h2>
                            <h2 class="wb">HTTPS://AFILIADOS.ECUABET.COM</h2>
                            
                        </div>
                      </div>
                    </div>
                </div><!-- /.row -->
            </div><!-- /.container -->
        </section>
        <section  id="work" *ngIf="config.partner != 8  && config.partner != 17" style="padding-top: 50px;">
                <div class="video-one">
                    <div class="container">
                        <div class="block-title text-center">
                            <h2 class="block-title__title title-choose-us pt-10" translate>¿Por qué elegirnos?</h2><!-- /.block-title__title -->
                        </div><!-- /.block-title -->
                        <!-- <div class="video-one__content">
                            <img src="/assets/images/video-1-1.jpg" alt="Awesome Image" />
                            <a href="https://www.youtube.com/watch?v=n-D1EB74Ckg" class="video-one__link video-popup"><i
                                    class="fa fa-play"></i></a>
                        </div>--><!-- /.video-one__content -->
                    </div><!-- /.container -->
                </div><!-- /.video-one -->
                <ngx-flicking
              class="flicking"
              [options]="{ circular: true, gap: 10, duration: 500 }"
              [plugins]="plugins"
            >
              <ng-template>
                <div class="panel" style="width: 100%" *ngFor="let item of homeWork">
                   <section class="cta-one">
                        <div class="container">
                            <div class="row justify-content-center">
                                <div class="col-lg-6">
                                    <div class="cta-one__content">
                                        <div class="block-title text-left">
                                            <h3 class="block-title__title h3">{{item.title}}</h3>
                                            <!-- /.block-title__title -->
                                        </div><!-- /.block-title -->
                                        <p class="cta-one__text">{{item.subtitle}}</p><!-- /.cta-one__text -->
                                        <ul class="cta-one__list">
                                            <li class="cta-one__list-item"><i class="fa fa-check"></i>{{item.text}}</li><!-- /.cta-one__list-item -->
                                            
                                        </ul><!-- /.cta-one__list -->
                                        <!--<a href="#" class="cta-one__btn thm-btn">Leer más</a>-->
                                    </div><!-- /.cta-one__content -->
                                </div><!-- /.col-lg-6 -->
                            <img src="/assets/images/home/metricas.png" class="cta-one__moc" alt="{{config.skinName}}" />
                            </div><!-- /.row -->
                        </div><!-- /.container -->
                    </section><!-- /.cta-one -->
                </div>
                
                
              </ng-template>
            </ngx-flicking>
            
        </section>
        
       
        
        
        
        <section *ngIf="config.partner != 8  && config.partner != 17" class="funfact-one" id="commissions">
            <img src="{{homeCommissions?.background}}" class="testimonials-one__background-image"
                alt="{{config.skinName}}" />
            <div class="container">
                <div class="block-title text-center">
                    <h2 class="block-title__title title-commissions" translate>Comisiones</h2><!-- /.block-title__title -->
                </div><!-- /.block-title -->
                <p class="cta-one__list-item commissions" [innerHTML]="homeCommissions?.text"></p>
                <br><br><br>
                <div class="row justify-content-center">
                    <div class="col-lg-3 col-md-6">
                        <div class="funfact-one__single">
                            <div class="inner">
                                <h3 class="funfact-one__title counter">{{homeCommissions?.step1}}</h3><!-- /.funfact-one__title -->
                                
                            </div><!-- /.inner -->
                        </div><!-- /.funfact-one__single -->
                    </div><!-- /.col-lg-3 -->
                    <div class="col-lg-1 col-md-1 d-flex justify-content-center">
                        <i class="fas fa-equals igual"></i>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex justify-content-center">
                        <div class="funfact-one__single">
                            <div class="inner">
                                <h3 class="funfact-one__title counter">{{homeCommissions?.step2}}</h3><!-- /.funfact-one__title -->
                                
                            </div><!-- /.inner -->
                        </div><!-- /.funfact-one__single -->
                    </div><!-- /.col-lg-3 -->
                    <div class="col-lg-1 col-md-1 d-flex justify-content-center">
                        <i class="fas fa-times igual"></i>
                    </div>
                   
                    <div class="col-lg-3 col-md-6 d-flex justify-content-center">
                        <div class="funfact-one__single">
                            <div class="inner">
                                <h3 class="funfact-one__title counter">{{homeCommissions?.step3}}</h3><!-- /.funfact-one__title -->
                               
                            </div><!-- /.inner -->
                        </div><!-- /.funfact-one__single -->
                    </div><!-- /.col-lg-3 -->
                    
                </div><!-- /.row -->
            </div><!-- /.container -->
        </section><!-- /.funfact-one -->
       
        <section *ngIf="config.partner != 8 && config.partner != 18  && config.partner != 17" class="service-one" id="requirements">
            <div class="container">
                <div class="block-title text-center">
                    <h2 class="block-title__title title-requirements" translate>¿Cuáles son los requisitos?<br></h2><!-- /.block-title__title -->
                </div><!-- /.block-title -->
                <div class="row justify-content-center">
                    <!-- /.col-lg-4 -->
                    <div class="col-lg-4 who" *ngFor="let item of homeRequirements">
                        <div class="service-one__single">
                            <div class="service-one__icon">
                                <i class="appyn-icon-businessman"><i class="{{item.icon}}"></i></i>
                            </div><!-- /.service-icon -->
                            <h3 class="service-one__title"><a href="#">{{item.title}}</a></h3>
                            <!-- /.service-one__title -->
                            <p class="service-one__text" [innerHTML]="item.text">
                            </p><!-- /.service-one__text -->
                        </div><!-- /.service-one__single -->
                    </div><!-- /.col-lg-4 -->
                   
                    
                </div><!-- /.row -->
            </div><!-- /.container -->
        </section><!-- /.service-one -->
        
    